import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Ionicon from 'react-ionicons';
import styles from './styles';
import Button from '@material-ui/core/Button';
import swal from 'sweetalert2';

import CloudDownload from '@material-ui/icons/CloudDownload';

// Custom Components
import LoginBlock from '../../components/LoginBlock';

import api from '../../api';

class Exports extends Component {
  state = {};

  _handleExcelExport = () => {
    api.getExcelExport();
  };

  _handleCSVExport = () => {
    api.getCsvExport();
  };

  _handleGoBack = () => {
    this.props.changePage('/more');
  };

  render() {
    const { loggedIn, classes } = this.props;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    return (
      <Grid container className={classes.root} spacing={0}>
        <span className={classes.backButton} onClick={this._handleGoBack}>
          <Ionicon
            icon="md-arrow-back"
            style={{
              marginRight: 5,
              marginBottom: 2,
              color: '#122B4F'
            }}
          />
          Back
        </span>

        <Grid item xs={12} className={classes.moreContainer}>
          <h1 className={classes.title}>Export Donation Data</h1>

          <div style={{ height: 50 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleCSVExport}
            className={classes.button}>
            <CloudDownload style={{ marginRight: 10 }} />
            CSV Export
          </Button>

          <div style={{ height: 20 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleExcelExport}
            className={classes.button}>
            <CloudDownload style={{ marginRight: 10 }} />
            Excel Export
          </Button>
        </Grid>
      </Grid>
    );
  }
}

Exports = withStyles(styles)(Exports);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Exports);



// WEBPACK FOOTER //
// ./src/containers/exports/index.js